import "./index.css";

export const LoaderPlain: React.FC = () => {
  return <span className="loader-plain"></span>;
};
